var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mt-5":"","mb-3":""}},[_c('h1',{staticClass:"display-2 font-weight-bold"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }